import React, { useEffect, useState } from "react";
import { getApiData } from "../../services/index";
import GetInTouch from "../Home/GetInTouch/GetInTouch";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const SponsorOblig = () => {
  const [metaTitle, setMetaTitle] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  const [services, setServices] = useState([]);

  const checkData = () => {
    const app = {};
    getApiData("api/get_corporate_services", app).then((result) => {
      if (result && result["status"] === 200) {
        setServices(result["data"]);
        const introductionData = result["data"].find(
          (service) => service.slug === "SponsorOblig"
        );
        if (introductionData) {
          setMetaTitle(introductionData.meta_title);
          setMetaKeywords(introductionData.meta_keyword);
          setMetaDescription(introductionData.meta_description);
        }
      }
    });
  };

  useEffect(() => {
    checkData();
  }, []);
  return (
    <>
      <Helmet>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>
      <div class="section">
        <div class="container services">
          <div class="page-grid">
            <div
              id="w-node-_78a8848c-b0d2-b571-b6c9-efe0422fa0f2-4b337bc0"
              class="sidebar"
            >
              <div className="foorer-list">
                <div className="footer-title">Corporate Services</div>
                <div className="w-dyn-list">
                  <div role="list" className="w-dyn-items">
                    <div role="listitem" className="w-dyn-item">
                      <Link
                        to="/Introduction"
                        className="footer-link-main w-inline-block"
                      >
                        <div>Introduction</div>
                      </Link>
                    </div>
                    <div role="listitem" className="w-dyn-item">
                      <Link
                        to="/SponsorVisaApp"
                        className="footer-link-main w-inline-block"
                      >
                        <div>Sponsor Visa Application Services</div>
                      </Link>
                    </div>
                    <div role="listitem" className="w-dyn-item">
                      <Link
                        to="/SkillInDemand"
                        className="footer-link-main w-inline-block"
                      >
                        <div>Skill in Demand Visa</div>
                      </Link>
                    </div>
                    <div role="listitem" className="w-dyn-item">
                      <Link
                        to="/EmployerNomVisa"
                        className="footer-link-main w-inline-block"
                      >
                        <div>Employer Nomination Scheme Visa </div>
                      </Link>
                    </div>
                    <div role="listitem" className="w-dyn-item">
                      <Link
                        to="/SkilledEmpSponRegionVisa "
                        className="footer-link-main w-inline-block"
                      >
                        <div>Skilled Employer Sponsored Regional Visa</div>
                      </Link>
                    </div>
                    <div role="listitem" className="w-dyn-item">
                      <Link
                        to="/SponsorOblig"
                        className="footer-link-main w-inline-block"
                      >
                        <div>Sponsorship Obligations</div>
                      </Link>
                    </div>
                    <div role="listitem" className="w-dyn-item">
                      <Link
                        to="/AppealingSponsoeVisa"
                        className="footer-link-main w-inline-block"
                      >
                        <div>Appealing an Employer- Sponsored Visa</div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="margin-50px"></div>
            </div>
            <div id="w-node-_55e1e50e-c8b8-b242-e39a-50ea90d98b40-4b337bc0">
              {services.length > 0 ? (
                services.map((service, index) =>
                  service.slug === "SponsorOblig" ? (
                    <div key={index}>
                      <div className="header-content">
                        <div>
                          <img
                            loading="lazy"
                            width="70"
                            alt=""
                            src={service.image}
                          />
                        </div>
                        <div className="margin-30px">
                          <h1 className="display-2">{service.title}</h1>
                        </div>
                        <div
                          className="margin-20px"
                          dangerouslySetInnerHTML={{
                            __html: service.description,
                          }}
                        ></div>
                      </div>
                    </div>
                  ) : null
                )
              ) : (
                <p>Loading...</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <GetInTouch />
    </>
  );
};

export default SponsorOblig;
